export function isZeroNegative(num: number) {
  const isZero = num === 0;
  const isNegative = 1 / num === -Infinity;
  return isNegative && isZero;
}
